import React from 'react';
import { styled, LazyImage } from '@teko/ui';

const StyledOrderImages = styled.div(() => `
height: auto;
.product-image {
  position: relative;
  background: #fff;
}
img {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fff;
}

.group {
  width: 64px;
  height: 64px;
  position: relative;
  .imageSecond {
    padding-top: 0;
    bottom: 80%;
    left: 20%;
  }
  img {
    width: 48px;
    height: 48px;
  }
}

&.small {
  height: 40px;
  width: 40px;
  img {
    width: 40px;
    height: 40px;
  }

  .group {
    width: 40px;
    height: 40px;

    img {
      width: 32px;
      height: 32px;
    }
  }
}
`);
const OrderImage = ({
  small,
  images,
  width
}) => {
  const imageJSX = () => {
    if (images.length === 1) {
      return /* @__PURE__ */ React.createElement("div", {
        className: "product-image",
        style: {
          width: width ? width : small ? "40px" : "64px",
          height: width || "auto"
        }
      }, /* @__PURE__ */ React.createElement(LazyImage, {
        src: `${images[0]}`,
        alt: ""
      }));
    } else if (images.length === 2) {
      return /* @__PURE__ */ React.createElement("div", {
        className: "group"
      }, /* @__PURE__ */ React.createElement("div", {
        className: "product-image"
      }, /* @__PURE__ */ React.createElement(LazyImage, {
        src: `${images[0]}`,
        alt: ""
      })), /* @__PURE__ */ React.createElement("div", {
        className: `product-image imageSecond`
      }, /* @__PURE__ */ React.createElement(LazyImage, {
        src: `${images[1]}`,
        alt: ""
      })));
    }
    return null;
  };
  return /* @__PURE__ */ React.createElement(StyledOrderImages, {
    className: `${small ? "small" : ""}`
  }, /* @__PURE__ */ React.createElement("div", null, imageJSX()));
};

export { OrderImage };
